<template>
  <div></div>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    data() {
      return {}
    },
    computed: {
      ...mapState({
        systemInfo: state => state.system,
      }),
      isZdd() {
        return this.$store.getters['system/isZdd']
      },
    },
    created() {
      if (this.isZdd) {
        this.$router.replace({
          path: '/zdd/home',
        })
      } else {
        this.$router.replace({
          path: '/HomePage',
        })
      }
    },
  }
</script>
